
import React, { useEffect } from "react";
import { store } from "../reducers";
import { userActions } from '../Actions/user.actions';


const routes=[
    { path: "/" },
    {path:'/how-to-access-ole'},
    {path:'/ashboard'},
    {path:'/course-page'},
    {path:'/taking-attendance'},
    {path:'/assignment'},
    {path:'/zoom-recording'},
    {path:'/teaching-tools'},

]

const deleteAllCookies=()=>{
        document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
    }
    
const checkUserLogin=async (navigate,returnToHomePage)=>{
        
        const Token=store.getState().userInfo.token;
        const oleResult=await userActions.getLtpaTokenUserNameIfValid()||{user_id:'Anonymous'};
        // console.log('oleResult',oleResult);
        if ((Token==null || Token ==="")&&oleResult.user_id=='Anonymous'){
            if (returnToHomePage)navigate('/Login', {replace: true});

            return false;
        }else {
            if (oleResult.user_id!='Anonymous'){
                console.log('oleResult',oleResult)
                if (store.getState().userInfo.username!=oleResult.user_id){
                    let data={username:oleResult.user_id,password:''};
                    store.dispatch({type:'SET_ISOLEACCOUNT',payload:true})
                    //await dispatch(getUserInfo(username));
                    store.dispatch({
                        type: 'SET_USERNAME_PASSWORD_AFTER_LOGIN',    
                        payload:data
                    });
                }
            }

            return true;
        }
    }
const courseLabelGenerate=(courseTitle)=>{ //course2202/phsin211f
    const tempseasoncode = (courseTitle.toString()).split('/');
    let seasoncode = ((tempseasoncode[0])?.replace("course","")).split("");
    // console.log("season",seasoncode);
    let year = "20" + seasoncode[0]+seasoncode[1];
    let season = "";
    Object.keys(Utility.semester).map(key => {
        if(key == seasoncode[2]+seasoncode[3]){
            season = Utility.semester[key];
        }
    });

    return (tempseasoncode[1]?.toUpperCase()) +" ("+ year + " " + season +")"
}


//CheckisStudent
// return true/false
const CheckisStudent = (props) => {
    // console.log("props@CheckRole:",props);
    return store.getState().userInfo.userType == "STUDENT" ? true : false;
}

//Check is admin
const CheckisAdmin = (props) =>{
    return props.userInfo.userInfoFromOle.is_admin;
}

const getStudentnamebyCourseandID = async(props,course,storeStudId,navigate) => { 

    const studentresult = await userActions.RequestStudentList(course);

    if(studentresult.result == 0 && props.userInfo.isOLEaccount == false){

        switch(studentresult.message) {
            case 'missing_token':
                navigate('/Login', {replace: true});
                break;
            case 'expired_token':
                store.dispatch({type:'SAVE_TOKEN',payload:""});
                navigate('/Login', {replace: true});
                break;
            case 'invalid_token':
                store.dispatch({type:'SAVE_TOKEN',payload:""});
                navigate('/Login', {replace: true});
                break;
            case 'no_access_right':
                navigate('/ActivityList', {replace: true});
                break;  
            case 'Object variable not set' : 
                store.dispatch({type:'SET_SELECTEDCOURSE',payload:""});
                store.dispatch({type:'SET_SELECTEDCOURSESEMESTER',payload:""});
                store.dispatch({type:'SET_SELECTEDACTIVITY',payload:""});
                store.dispatch({type:'SET_SELECTEDACTIVITYID',payload:""});
                navigate('/ActivityList', {replace: true});
                break;                  
            default:
                break;
        }
    }
    else{
        if(Object.keys(studentresult).length <=0){
            console.log("No Any Student at this course");
            store.dispatch({type:'SET_SELECTEDCOURSE',payload:""});
            store.dispatch({type:'SET_SELECTEDCOURSESEMESTER',payload:""});
            store.dispatch({type:'SET_SELECTEDACTIVITY',payload:""});
            store.dispatch({type:'SET_SELECTEDACTIVITYID',payload:""});
            navigate('/ActivityList', {replace: true});
        }else{

            // console.log(studentresult.students);
            let i=0;
            const tempstudentlist = Object.keys(studentresult.students);
            for(i=0;i<tempstudentlist.length;i++){
                // console.log(tempstudentlist[i] + "/" + studentresult.students[tempstudentlist[i]].sid);
                if(tempstudentlist[i] == storeStudId || studentresult.students[tempstudentlist[i]].sid == storeStudId){
                    // console.log(studentresult.students[tempstudentlist[i]].name);
                    // setData({...Data,StudentName:studentresult.students[tempstudentlist[i]].name});
                    // store.dispatch({type:'SET_SELECTEDSTUDENTNAME',payload:studentresult.students[tempstudentlist[i]].name});
                    return studentresult.students[tempstudentlist[i]].name;
                    break;
                }
            }

            // const result = Object.keys(studentresult.students).map(key => {
            //     const tempname = studentresult.students[key].name;
            //     const tempid = studentresult.students[key].sid;
            //     if(tempid == storeStudId){
            //         // tempname;
            //         setData({...Data,StudentName:tempname});
            //     }
            // });
        }
    }
}


const convertToUserId = (sid) =>{
    try{
        var a = sid.substr(1,1);
        var b = sid.substr(2,1);
        var c = sid.substr(3,1);
        var d = sid.substr(4,1);
        var e = sid.substr(5,1);
        var f = sid.substr(6,1);
        var g = sid.substr(7,1);
        var semi_chkdgt = (a*128+b*64+c*32+d*16+e*8+f*4+g*2) % 11;
        semi_chkdgt = (semi_chkdgt == 10) ? 0: semi_chkdgt;
        return sid.substr(1,7)+semi_chkdgt;
    }
    catch(err){
        return sid;
    }
}


const semester={
        "11": "Spring",
        "13": "Summer",
        "15": "Autumn",
        "21": "Jan",
        "22": "Feb",
        "23": "Mar",
        "24": "Apr",
        "25": "May",
        "26": "Jun",
        "27": "Jul",
        "28": "Aug",
        "29": "Sep",
        "30": "Oct",
        "31": "Nov",
        "32": "Dec",
        "00": "Spring",
        "01": "Spring",
        "02": "Summer",
        "05": "Summer",
        "04": "Autumn",
        "09": "Autumn",
        "S1A": "Autumn",
        "S2A": "Autumn",
        "S3A": "Autumn",
        "S1B": "Spring",
        "S2B": "Spring",
        "S3B": "Spring"
      };
    
export const Utility = {
    deleteAllCookies,
    checkUserLogin,
    semester,
    courseLabelGenerate,
    CheckisStudent,
    CheckisAdmin,
    getStudentnamebyCourseandID,
    convertToUserId,
    routes
}

